import { rootApi } from 'root-api'

/**
 * Whether Statsig should wait before mounting StatsigProvider.
 *
 * Blocks while getEventType is pending or rejected. 'rejected' must block to
 * avoid a remount loop: unmounting StatsigProvider causes the subtree to
 * resubscribe, retrying the failed query indefinitely.
 *
 * On WithInvitee routes (e.g. reschedule), getEventType is triggered by the
 * invitee response, so getEventType stays 'uninitialized' until getInvitee
 * settles. We also block during this window to prevent Statsig from initializing
 * with a partial user before host/org fields are available.
 */
export const isEventTypeUnresolvedSelector = (state) => {
  const { status: eventTypeStatus } = rootApi.endpoints.getEventType.select()(state)
  const { status: inviteeStatus, data: inviteeData } = rootApi.endpoints.getInvitee.select()(state)

  if (eventTypeStatus === 'pending' || eventTypeStatus === 'rejected') return true

  if (eventTypeStatus === 'uninitialized') {
    if (inviteeStatus === 'pending') return true

    // getEventType/pending is dispatched one commit after the invitee resolves.
    // Block during that gap so Statsig doesn't initialize before the fetch starts.
    if (inviteeStatus === 'fulfilled' && inviteeData?.scheduling_link?.owner_type === 'Share') return true
  }

  return false
}
